import { createScheduleComponent } from '@play-co/components';
import { duration } from '../../utils/duration';
import { Match2Reward } from '../rewards/match2-rewards.ruleset';

/** Feature unlock level */
export const match2BundleSaleUnlockLevel = 20;

/** Rewards of products */
export type BundleSaleRewards = {
  free: boolean;
  rewards: Match2Reward[];
};

/** List of products available for this feature */
export const bundleSaleProducts = [
  // Legacy products
  'buruburu_booster_sale',
  'buruburu_bundle_sale_gems',
  'buruburu_bundle_sale_powerups',
  'buruburu_bundle_sale_roulette',
  'buruburu_bundle_sale_unlimited_energy',
  'buruburu_bundle_sale_bullet_drill',
  // New products RM
  'buruburu_sale_rm_01',
  'buruburu_sale_rm_01_xmas',
  'buruburu_sale_rm_02',
  'buruburu_sale_rm_03',
  'buruburu_sale_rm_04p_2',
  'buruburu_sale_rm_05',
  'buruburu_sale_rm_06',
  'buruburu_sale_rm_07',
  'buruburu_sale_rm_08',
  'buruburu_sale_rm_09',
  'buruburu_sale_rm_10p',
  'buruburu_sale_rm_11',
  'buruburu_sale_rm_12',
  'buruburu_sale_rm_13',
  'buruburu_sale_rm_14',
  'buruburu_sale_rm_15',
  'buruburu_sale_rm_16p',
  'buruburu_sale_rm_17',
  'buruburu_sale_rm_18',
  'buruburu_sale_rm_19',
  'buruburu_sale_rm_20',
  'buruburu_sale_rm_21',
  'buruburu_sale_rm_22p',
  'buruburu_sale_rm_23',
  'buruburu_sale_rm_24',
  'buruburu_sale_rm_25',
  'buruburu_sale_rm_26',
  'buruburu_sale_rm_27',
  'buruburu_sale_rm_28p',
  'buruburu_sale_rm_29',
  'buruburu_sale_rm_30',
  'buruburu_sale_rm_31',
  'buruburu_sale_rm_32',
  'buruburu_sale_rm_33',
  'buruburu_sale_rm_34p',
  'buruburu_sale_rm_35',
  'buruburu_sale_rm_36',
  'buruburu_sale_rm_37',
  'buruburu_sale_rm_38',
  'buruburu_sale_rm_39',
  'buruburu_sale_rm_40p',
  'buruburu_sale_rm_41',
  'buruburu_sale_rm_42',
  'buruburu_sale_rm_43',
  'buruburu_sale_rm_44',
  'buruburu_sale_rm_45',
  'buruburu_sale_rm_46p',
  'buruburu_sale_rm_47',
  'buruburu_sale_rm_48',
  'buruburu_sale_rm_49',
  'buruburu_sale_rm_50',
  'buruburu_sale_rm_51',
  // New products CM
  'buruburu_sale_cm_01',
  'buruburu_sale_cm_02',
  'buruburu_sale_cm_03',
  'buruburu_sale_cm_04p',
  'buruburu_sale_cm_05',
  'buruburu_sale_cm_06',
  'buruburu_sale_cm_07',
  'buruburu_sale_cm_08',
  'buruburu_sale_cm_09',
  'buruburu_sale_cm_10p',
  'buruburu_sale_cm_11',
  'buruburu_sale_cm_12',
  'buruburu_sale_cm_13',
  'buruburu_sale_cm_14',
  'buruburu_sale_cm_15',
  'buruburu_sale_cm_16p',
  'buruburu_sale_cm_17',
  'buruburu_sale_cm_18',
  'buruburu_sale_cm_19',
  'buruburu_sale_cm_20',
  'buruburu_sale_cm_21',
  'buruburu_sale_cm_22p',
  'buruburu_sale_cm_23',
  'buruburu_sale_cm_24',
  'buruburu_sale_cm_25',
  'buruburu_sale_cm_26',
  'buruburu_sale_cm_27',
  'buruburu_sale_cm_28p',
  'buruburu_sale_cm_29',
  'buruburu_sale_cm_30',
  'buruburu_sale_cm_31',
  'buruburu_sale_cm_32',
  'buruburu_sale_cm_33',
  'buruburu_sale_cm_34p',
  'buruburu_sale_cm_35',
  'buruburu_sale_cm_36',
  'buruburu_sale_cm_37',
  'buruburu_sale_cm_38',
  'buruburu_sale_cm_39',
  'buruburu_sale_cm_40p',
  'buruburu_sale_cm_41',
  'buruburu_sale_cm_42',
  'buruburu_sale_cm_43',
  'buruburu_sale_cm_44',
  'buruburu_sale_cm_45',
  'buruburu_sale_cm_46p',
  'buruburu_sale_cm_47',
  'buruburu_sale_cm_48',
  'buruburu_sale_cm_49',
  'buruburu_sale_cm_50',
  'buruburu_sale_cm_51',
  'buruburu_sale_cm_52p',
  'buruburu_sale_cm_53',
  'buruburu_sale_cm_54',
  'buruburu_sale_cm_55',
  'buruburu_sale_cm_56',
  'buruburu_sale_cm_57',
  'buruburu_sale_cm_58p',
  'buruburu_sale_cm_59',
  'buruburu_sale_cm_60',
  'buruburu_sale_cm_61',
  'buruburu_sale_cm_62',
  'buruburu_sale_cm_63',
] as const;

/** Valid bundle sale product id */
export type BundleSaleProductId = (typeof bundleSaleProducts)[number];

/** List of rewards per product - paid products should also be registered in iap.ruleset too */
export const bundleSaleRewards: Record<BundleSaleProductId, BundleSaleRewards> =
  {
    // === Legacy Producs =====================================================
    buruburu_booster_sale: {
      free: false,
      rewards: [{ type: 'gems', amount: 1500 }],
    },
    buruburu_bundle_sale_gems: {
      free: true,
      rewards: [{ type: 'gems', amount: 50 }],
    },
    buruburu_bundle_sale_powerups: {
      free: true,
      rewards: [{ type: 'wrapper', id: 'all_powerups', amount: 1 }],
    },
    buruburu_bundle_sale_roulette: {
      free: true,
      rewards: [{ type: 'boosters', subType: 'roulette', amount: 1 }],
    },
    buruburu_bundle_sale_unlimited_energy: {
      free: true,
      rewards: [{ type: 'energy', duration: duration({ minutes: 15 }) }],
    },
    buruburu_bundle_sale_bullet_drill: {
      free: true,
      rewards: [
        { type: 'boosters', subType: 'bullet', amount: 1 },
        { type: 'boosters', subType: 'drill', amount: 1 },
      ],
    },
    // === New products RM ====================================================
    buruburu_sale_rm_01: {
      free: true,
      rewards: [{ type: 'boosters', subType: 'dart', amount: 1 }],
    },
    buruburu_sale_rm_01_xmas: {
      free: true,
      rewards: [
        { type: 'boosters', subType: 'dart', amount: 1 },
        {
          type: 'roomDecoration',
          theme: '06_happy_xmas',
          color: 'b',
          tier: 3,
        },
      ],
    },
    buruburu_sale_rm_02: {
      free: true,
      rewards: [{ type: 'gems', amount: 50 }],
    },
    buruburu_sale_rm_03: {
      free: true,
      rewards: [
        { type: 'gems', amount: 50 },
        { type: 'powerups', subType: 'bomb', amount: 1 },
        { type: 'powerups', subType: 'rocket', amount: 1 },
        { type: 'powerups', subType: 'cube', amount: 1 },
      ],
    },
    buruburu_sale_rm_04p_2: {
      free: false,
      rewards: [
        { type: 'gems', amount: 1500 },
        { type: 'boosters', subType: 'dart', amount: 1 },
        { type: 'powerups', subType: 'bomb', amount: 1 },
      ],
    },
    buruburu_sale_rm_05: {
      free: true,
      rewards: [{ type: 'gems', amount: 100 }],
    },
    buruburu_sale_rm_06: {
      free: true,
      rewards: [
        { type: 'powerups', subType: 'bomb', amount: 2 },
        { type: 'powerups', subType: 'rocket', amount: 2 },
        { type: 'powerups', subType: 'cube', amount: 2 },
      ],
    },
    buruburu_sale_rm_07: {
      free: true,
      rewards: [{ type: 'boosters', subType: 'bullet', amount: 1 }],
    },
    buruburu_sale_rm_08: {
      free: true,
      rewards: [{ type: 'boosters', subType: 'drill', amount: 1 }],
    },
    buruburu_sale_rm_09: {
      free: true,
      rewards: [{ type: 'boosters', subType: 'roulette', amount: 1 }],
    },
    buruburu_sale_rm_10p: {
      free: false,
      rewards: [
        { type: 'gems', amount: 2000 },
        { type: 'boosters', subType: 'dart', amount: 1 },
        { type: 'boosters', subType: 'bullet', amount: 1 },
        { type: 'boosters', subType: 'drill', amount: 1 },
        { type: 'boosters', subType: 'roulette', amount: 1 },
        { type: 'powerups', subType: 'bomb', amount: 2 },
      ],
    },
    buruburu_sale_rm_11: {
      free: true,
      rewards: [
        { type: 'powerups', subType: 'bomb', amount: 1 },
        { type: 'powerups', subType: 'rocket', amount: 1 },
        { type: 'powerups', subType: 'cube', amount: 1 },
      ],
    },
    buruburu_sale_rm_12: {
      free: true,
      rewards: [{ type: 'boosters', subType: 'drill', amount: 2 }],
    },
    buruburu_sale_rm_13: {
      free: true,
      rewards: [{ type: 'boosters', subType: 'dart', amount: 2 }],
    },
    buruburu_sale_rm_14: {
      free: true,
      rewards: [{ type: 'boosters', subType: 'roulette', amount: 1 }],
    },
    buruburu_sale_rm_15: {
      free: true,
      rewards: [{ type: 'boosters', subType: 'bullet', amount: 2 }],
    },
    buruburu_sale_rm_16p: {
      free: false,
      rewards: [
        { type: 'gems', amount: 2500 },
        { type: 'boosters', subType: 'dart', amount: 2 },
        { type: 'powerups', subType: 'bomb', amount: 2 },
      ],
    },
    buruburu_sale_rm_17: {
      free: true,
      rewards: [
        { type: 'energy', duration: duration({ minutes: 15 }) },
        { type: 'boosters', subType: 'drill', amount: 2 },
        { type: 'boosters', subType: 'roulette', amount: 1 },
      ],
    },
    buruburu_sale_rm_18: {
      free: true,
      rewards: [
        {
          type: 'powerups',
          subType: 'rocket',
          duration: duration({ minutes: 30 }),
        },
      ],
    },
    buruburu_sale_rm_19: {
      free: true,
      rewards: [
        {
          type: 'powerups',
          subType: 'bomb',
          duration: duration({ minutes: 30 }),
        },
      ],
    },
    buruburu_sale_rm_20: {
      free: true,
      rewards: [
        {
          type: 'powerups',
          subType: 'cube',
          duration: duration({ minutes: 30 }),
        },
      ],
    },
    buruburu_sale_rm_21: {
      free: true,
      rewards: [{ type: 'energy', duration: duration({ minutes: 15 }) }],
    },
    buruburu_sale_rm_22p: {
      free: false,
      rewards: [
        { type: 'gems', amount: 3000 },
        { type: 'boosters', subType: 'bullet', amount: 3 },
        { type: 'boosters', subType: 'drill', amount: 3 },
      ],
    },
    buruburu_sale_rm_23: {
      free: true,
      rewards: [{ type: 'gems', amount: 1600 }],
    },
    buruburu_sale_rm_24: {
      free: true,
      rewards: [
        { type: 'gems', amount: 1000 },
        { type: 'powerups', subType: 'bomb', amount: 3 },
        { type: 'powerups', subType: 'rocket', amount: 3 },
      ],
    },
    buruburu_sale_rm_25: {
      free: true,
      rewards: [{ type: 'boosters', subType: 'dart', amount: 3 }],
    },
    buruburu_sale_rm_26: {
      free: true,
      rewards: [
        { type: 'gems', amount: 250 },
        { type: 'powerups', subType: 'bomb', amount: 3 },
        { type: 'powerups', subType: 'rocket', amount: 3 },
        { type: 'powerups', subType: 'cube', amount: 3 },
      ],
    },
    buruburu_sale_rm_27: {
      free: true,
      rewards: [{ type: 'boosters', subType: 'roulette', amount: 3 }],
    },
    buruburu_sale_rm_28p: {
      free: false,
      rewards: [
        { type: 'gems', amount: 2500 },
        { type: 'boosters', subType: 'bullet', amount: 3 },
        {
          type: 'powerups',
          subType: 'bomb',
          duration: duration({ hours: 1 }),
        },
      ],
    },
    buruburu_sale_rm_29: {
      free: true,
      rewards: [{ type: 'gems', amount: 2000 }],
    },
    buruburu_sale_rm_30: {
      free: true,
      rewards: [
        {
          type: 'powerups',
          subType: 'cube',
          duration: duration({ hours: 1 }),
        },
      ],
    },
    buruburu_sale_rm_31: {
      free: true,
      rewards: [{ type: 'gems', amount: 2000 }],
    },
    buruburu_sale_rm_32: {
      free: true,
      rewards: [{ type: 'energy', duration: duration({ hours: 1 }) }],
    },
    buruburu_sale_rm_33: {
      free: true,
      rewards: [
        { type: 'gems', amount: 1000 },
        { type: 'boosters', subType: 'drill', amount: 3 },
        {
          type: 'powerups',
          subType: 'rocket',
          duration: duration({ hours: 1 }),
        },
      ],
    },
    buruburu_sale_rm_34p: {
      free: false,
      rewards: [
        { type: 'gems', amount: 5000 },
        { type: 'boosters', subType: 'dart', amount: 5 },
        { type: 'boosters', subType: 'roulette', amount: 5 },
      ],
    },
    buruburu_sale_rm_35: {
      free: true,
      rewards: [{ type: 'gems', amount: 3500 }],
    },
    buruburu_sale_rm_36: {
      free: true,
      rewards: [{ type: 'powerups', subType: 'bomb', amount: 5 }],
    },
    buruburu_sale_rm_37: {
      free: true,
      rewards: [{ type: 'gems', amount: 3000 }],
    },
    buruburu_sale_rm_38: {
      free: true,
      rewards: [
        { type: 'gems', amount: 1300 },
        { type: 'boosters', subType: 'bullet', amount: 5 },
        { type: 'boosters', subType: 'drill', amount: 5 },
      ],
    },
    buruburu_sale_rm_39: {
      free: true,
      rewards: [{ type: 'powerups', subType: 'rocket', amount: 5 }],
    },
    buruburu_sale_rm_40p: {
      free: false,
      rewards: [
        { type: 'gems', amount: 8000 },
        { type: 'boosters', subType: 'drill', amount: 10 },
        { type: 'powerups', subType: 'cube', amount: 10 },
      ],
    },
    buruburu_sale_rm_41: {
      free: true,
      rewards: [{ type: 'gems', amount: 6250 }],
    },
    buruburu_sale_rm_42: {
      free: true,
      rewards: [{ type: 'boosters', subType: 'bullet', amount: 10 }],
    },
    buruburu_sale_rm_43: {
      free: true,
      rewards: [{ type: 'gems', amount: 4500 }],
    },
    buruburu_sale_rm_44: {
      free: true,
      rewards: [{ type: 'powerups', subType: 'rocket', amount: 10 }],
    },
    buruburu_sale_rm_45: {
      free: true,
      rewards: [
        { type: 'gems', amount: 4000 },
        { type: 'boosters', subType: 'dart', amount: 10 },
        { type: 'powerups', subType: 'bomb', amount: 10 },
      ],
    },
    buruburu_sale_rm_46p: {
      free: false,
      rewards: [
        { type: 'gems', amount: 18000 },
        { type: 'energy', duration: duration({ hours: 12 }) },
        {
          type: 'powerups',
          subType: 'bomb',
          duration: duration({ hours: 24 }),
        },
      ],
    },
    buruburu_sale_rm_47: {
      free: true,
      rewards: [{ type: 'gems', amount: 1300 }],
    },
    buruburu_sale_rm_48: {
      free: true,
      rewards: [
        {
          type: 'powerups',
          subType: 'cube',
          duration: duration({ hours: 24 }),
        },
      ],
    },
    buruburu_sale_rm_49: {
      free: true,
      rewards: [{ type: 'gems', amount: 11000 }],
    },
    buruburu_sale_rm_50: {
      free: true,
      rewards: [
        { type: 'gems', amount: 7500 },
        { type: 'boosters', subType: 'dart', amount: 12 },
        {
          type: 'powerups',
          subType: 'rocket',
          duration: duration({ hours: 24 }),
        },
      ],
    },
    buruburu_sale_rm_51: {
      free: true,
      rewards: [
        { type: 'gems', amount: 10000 },
        { type: 'boosters', subType: 'dart', amount: 12 },
        { type: 'boosters', subType: 'bullet', amount: 12 },
        { type: 'boosters', subType: 'drill', amount: 12 },
        { type: 'boosters', subType: 'roulette', amount: 12 },
      ],
    },
    // === New products CM ====================================================
    buruburu_sale_cm_01: {
      free: true,
      rewards: [{ type: 'boosters', subType: 'dart', amount: 1 }],
    },
    buruburu_sale_cm_02: {
      free: true,
      rewards: [{ type: 'gems', amount: 50 }],
    },
    buruburu_sale_cm_03: {
      free: true,
      rewards: [
        { type: 'gems', amount: 50 },
        { type: 'powerups', subType: 'bomb', amount: 1 },
        { type: 'powerups', subType: 'rocket', amount: 1 },
        { type: 'powerups', subType: 'cube', amount: 1 },
      ],
    },
    buruburu_sale_cm_04p: {
      free: false,
      rewards: [
        { type: 'gems', amount: 1000 },
        { type: 'boosters', subType: 'dart', amount: 1 },
        { type: 'powerups', subType: 'bomb', amount: 1 },
      ],
    },
    buruburu_sale_cm_05: {
      free: true,
      rewards: [{ type: 'gems', amount: 100 }],
    },
    buruburu_sale_cm_06: {
      free: true,
      rewards: [
        { type: 'powerups', subType: 'bomb', amount: 2 },
        { type: 'powerups', subType: 'rocket', amount: 2 },
        { type: 'powerups', subType: 'cube', amount: 2 },
      ],
    },
    buruburu_sale_cm_07: {
      free: true,
      rewards: [{ type: 'boosters', subType: 'bullet', amount: 1 }],
    },
    buruburu_sale_cm_08: {
      free: true,
      rewards: [{ type: 'boosters', subType: 'drill', amount: 1 }],
    },
    buruburu_sale_cm_09: {
      free: true,
      rewards: [{ type: 'boosters', subType: 'roulette', amount: 1 }],
    },
    buruburu_sale_cm_10p: {
      free: false,
      rewards: [
        { type: 'gems', amount: 1500 },
        { type: 'boosters', subType: 'dart', amount: 1 },
        { type: 'boosters', subType: 'bullet', amount: 1 },
        { type: 'boosters', subType: 'drill', amount: 1 },
        { type: 'boosters', subType: 'roulette', amount: 1 },
        { type: 'powerups', subType: 'bomb', amount: 2 },
      ],
    },
    buruburu_sale_cm_11: {
      free: true,
      rewards: [
        { type: 'powerups', subType: 'bomb', amount: 1 },
        { type: 'powerups', subType: 'rocket', amount: 1 },
        { type: 'powerups', subType: 'cube', amount: 1 },
      ],
    },
    buruburu_sale_cm_12: {
      free: true,
      rewards: [{ type: 'boosters', subType: 'drill', amount: 2 }],
    },
    buruburu_sale_cm_13: {
      free: true,
      rewards: [{ type: 'boosters', subType: 'dart', amount: 2 }],
    },
    buruburu_sale_cm_14: {
      free: true,
      rewards: [{ type: 'boosters', subType: 'roulette', amount: 2 }],
    },
    buruburu_sale_cm_15: {
      free: true,
      rewards: [{ type: 'boosters', subType: 'bullet', amount: 2 }],
    },
    buruburu_sale_cm_16p: {
      free: false,
      rewards: [
        { type: 'gems', amount: 2000 },
        { type: 'boosters', subType: 'dart', amount: 2 },
        { type: 'powerups', subType: 'bomb', amount: 2 },
      ],
    },
    buruburu_sale_cm_17: {
      free: true,
      rewards: [
        { type: 'energy', duration: duration({ minutes: 15 }) },
        { type: 'boosters', subType: 'drill', amount: 2 },
        { type: 'boosters', subType: 'roulette', amount: 1 },
      ],
    },
    buruburu_sale_cm_18: {
      free: true,
      rewards: [
        {
          type: 'powerups',
          subType: 'rocket',
          duration: duration({ minutes: 30 }),
        },
      ],
    },
    buruburu_sale_cm_19: {
      free: true,
      rewards: [
        {
          type: 'powerups',
          subType: 'bomb',
          duration: duration({ minutes: 30 }),
        },
      ],
    },
    buruburu_sale_cm_20: {
      free: true,
      rewards: [
        {
          type: 'powerups',
          subType: 'cube',
          duration: duration({ minutes: 30 }),
        },
      ],
    },
    buruburu_sale_cm_21: {
      free: true,
      rewards: [{ type: 'energy', duration: duration({ minutes: 15 }) }],
    },
    buruburu_sale_cm_22p: {
      free: false,
      rewards: [
        { type: 'gems', amount: 3000 },
        { type: 'boosters', subType: 'bullet', amount: 3 },
        { type: 'boosters', subType: 'drill', amount: 3 },
      ],
    },
    buruburu_sale_cm_23: {
      free: true,
      rewards: [{ type: 'gems', amount: 1600 }],
    },
    buruburu_sale_cm_24: {
      free: true,
      rewards: [
        { type: 'gems', amount: 1000 },
        { type: 'powerups', subType: 'bomb', amount: 3 },
        { type: 'powerups', subType: 'rocket', amount: 3 },
      ],
    },
    buruburu_sale_cm_25: {
      free: true,
      rewards: [{ type: 'boosters', subType: 'dart', amount: 3 }],
    },
    buruburu_sale_cm_26: {
      free: true,
      rewards: [
        { type: 'gems', amount: 250 },
        { type: 'powerups', subType: 'bomb', amount: 3 },
        { type: 'powerups', subType: 'rocket', amount: 3 },
        { type: 'powerups', subType: 'cube', amount: 3 },
      ],
    },
    buruburu_sale_cm_27: {
      free: true,
      rewards: [{ type: 'boosters', subType: 'roulette', amount: 3 }],
    },
    buruburu_sale_cm_28p: {
      free: false,
      rewards: [
        { type: 'gems', amount: 2400 },
        { type: 'boosters', subType: 'bullet', amount: 3 },
        {
          type: 'powerups',
          subType: 'bomb',
          duration: duration({ hours: 1 }),
        },
      ],
    },
    buruburu_sale_cm_29: {
      free: true,
      rewards: [{ type: 'gems', amount: 2000 }],
    },
    buruburu_sale_cm_30: {
      free: true,
      rewards: [
        {
          type: 'powerups',
          subType: 'cube',
          duration: duration({ hours: 1 }),
        },
      ],
    },
    buruburu_sale_cm_31: {
      free: true,
      rewards: [{ type: 'gems', amount: 2000 }],
    },
    buruburu_sale_cm_32: {
      free: true,
      rewards: [{ type: 'energy', duration: duration({ hours: 1 }) }],
    },
    buruburu_sale_cm_33: {
      free: true,
      rewards: [
        { type: 'gems', amount: 1000 },
        { type: 'boosters', subType: 'drill', amount: 3 },
        {
          type: 'powerups',
          subType: 'rocket',
          duration: duration({ hours: 1 }),
        },
      ],
    },
    buruburu_sale_cm_34p: {
      free: false,
      rewards: [
        { type: 'gems', amount: 4000 },
        { type: 'boosters', subType: 'bullet', amount: 4 },
        { type: 'boosters', subType: 'drill', amount: 4 },
      ],
    },
    buruburu_sale_cm_35: {
      free: true,
      rewards: [{ type: 'gems', amount: 2500 }],
    },
    buruburu_sale_cm_36: {
      free: true,
      rewards: [
        { type: 'gems', amount: 2000 },
        { type: 'powerups', subType: 'rocket', amount: 4 },
        { type: 'powerups', subType: 'bomb', amount: 4 },
      ],
    },
    buruburu_sale_cm_37: {
      free: true,
      rewards: [{ type: 'boosters', subType: 'dart', amount: 4 }],
    },
    buruburu_sale_cm_38: {
      free: true,
      rewards: [
        { type: 'gems', amount: 500 },
        { type: 'powerups', subType: 'rocket', amount: 4 },
        { type: 'powerups', subType: 'bomb', amount: 4 },
        { type: 'powerups', subType: 'cube', amount: 4 },
      ],
    },
    buruburu_sale_cm_39: {
      free: true,
      rewards: [{ type: 'boosters', subType: 'roulette', amount: 4 }],
    },
    buruburu_sale_cm_40p: {
      free: false,
      rewards: [
        { type: 'gems', amount: 5000 },
        { type: 'boosters', subType: 'dart', amount: 5 },
        { type: 'boosters', subType: 'roulette', amount: 5 },
      ],
    },
    buruburu_sale_cm_41: {
      free: true,
      rewards: [{ type: 'gems', amount: 3500 }],
    },
    buruburu_sale_cm_42: {
      free: true,
      rewards: [{ type: 'powerups', subType: 'bomb', amount: 5 }],
    },
    buruburu_sale_cm_43: {
      free: true,
      rewards: [{ type: 'gems', amount: 3000 }],
    },
    buruburu_sale_cm_44: {
      free: true,
      rewards: [
        { type: 'gems', amount: 1300 },
        { type: 'boosters', subType: 'bullet', amount: 5 },
        { type: 'boosters', subType: 'drill', amount: 5 },
      ],
    },
    buruburu_sale_cm_45: {
      free: true,
      rewards: [{ type: 'powerups', subType: 'rocket', amount: 5 }],
    },
    buruburu_sale_cm_46p: {
      free: false,
      rewards: [
        { type: 'gems', amount: 6500 },
        { type: 'boosters', subType: 'dart', amount: 7 },
        { type: 'boosters', subType: 'roulette', amount: 7 },
      ],
    },
    buruburu_sale_cm_47: {
      free: true,
      rewards: [{ type: 'gems', amount: 4500 }],
    },
    buruburu_sale_cm_48: {
      free: true,
      rewards: [{ type: 'powerups', subType: 'bomb', amount: 7 }],
    },
    buruburu_sale_cm_49: {
      free: true,
      rewards: [{ type: 'gems', amount: 4000 }],
    },
    buruburu_sale_cm_50: {
      free: true,
      rewards: [
        { type: 'gems', amount: 1800 },
        { type: 'boosters', subType: 'bullet', amount: 7 },
        { type: 'boosters', subType: 'drill', amount: 7 },
      ],
    },
    buruburu_sale_cm_51: {
      free: true,
      rewards: [{ type: 'powerups', subType: 'rocket', amount: 7 }],
    },
    buruburu_sale_cm_52p: {
      free: false,
      rewards: [
        { type: 'gems', amount: 8000 },
        { type: 'boosters', subType: 'drill', amount: 10 },
        { type: 'powerups', subType: 'cube', amount: 10 },
      ],
    },
    buruburu_sale_cm_53: {
      free: true,
      rewards: [{ type: 'gems', amount: 6250 }],
    },
    buruburu_sale_cm_54: {
      free: true,
      rewards: [{ type: 'boosters', subType: 'bullet', amount: 10 }],
    },
    buruburu_sale_cm_55: {
      free: true,
      rewards: [{ type: 'gems', amount: 4500 }],
    },
    buruburu_sale_cm_56: {
      free: true,
      rewards: [{ type: 'powerups', subType: 'rocket', amount: 10 }],
    },
    buruburu_sale_cm_57: {
      free: true,
      rewards: [
        { type: 'gems', amount: 4000 },
        { type: 'boosters', subType: 'dart', amount: 10 },
        { type: 'powerups', subType: 'bomb', amount: 10 },
      ],
    },
    buruburu_sale_cm_58p: {
      free: false,
      rewards: [
        { type: 'gems', amount: 18000 },
        {
          type: 'powerups',
          subType: 'bomb',
          duration: duration({ hours: 24 }),
        },
      ],
    },
    buruburu_sale_cm_59: {
      free: true,
      rewards: [{ type: 'gems', amount: 13000 }],
    },
    buruburu_sale_cm_60: {
      free: true,
      rewards: [
        {
          type: 'powerups',
          subType: 'cube',
          duration: duration({ hours: 24 }),
        },
      ],
    },
    buruburu_sale_cm_61: {
      free: true,
      rewards: [{ type: 'gems', amount: 11000 }],
    },
    buruburu_sale_cm_62: {
      free: true,
      rewards: [
        { type: 'gems', amount: 7500 },
        { type: 'boosters', subType: 'dart', amount: 12 },
        {
          type: 'powerups',
          subType: 'rocket',
          duration: duration({ hours: 24 }),
        },
      ],
    },
    buruburu_sale_cm_63: {
      free: true,
      rewards: [
        { type: 'gems', amount: 10000 },
        { type: 'boosters', subType: 'dart', amount: 12 },
        { type: 'boosters', subType: 'bullet', amount: 12 },
        { type: 'boosters', subType: 'drill', amount: 12 },
        { type: 'boosters', subType: 'roulette', amount: 12 },
      ],
    },
  };

/** Define a bundle sale event */
export type BundleSaleEvent = {
  items: BundleSaleProductId[];
};

/** Legacy event, kept for reference */
const boosterSale: BundleSaleEvent = {
  items: [
    'buruburu_bundle_sale_roulette',
    'buruburu_bundle_sale_gems',
    'buruburu_bundle_sale_powerups',
    'buruburu_booster_sale',
    'buruburu_bundle_sale_unlimited_energy',
    'buruburu_bundle_sale_bullet_drill',
  ],
};

/** Default event */
const endlessSale: BundleSaleEvent = {
  items: [
    'buruburu_sale_rm_01',
    'buruburu_sale_rm_02',
    'buruburu_sale_rm_03',
    'buruburu_sale_rm_04p_2',
    'buruburu_sale_rm_05',
    'buruburu_sale_rm_06',
    'buruburu_sale_rm_07',
    'buruburu_sale_rm_08',
    'buruburu_sale_rm_09',
    'buruburu_sale_rm_10p',
    'buruburu_sale_rm_11',
    'buruburu_sale_rm_12',
    'buruburu_sale_rm_13',
    'buruburu_sale_rm_14',
    'buruburu_sale_rm_15',
    'buruburu_sale_rm_16p',
    'buruburu_sale_rm_17',
    'buruburu_sale_rm_18',
    'buruburu_sale_rm_19',
    'buruburu_sale_rm_20',
    'buruburu_sale_rm_21',
    'buruburu_sale_rm_22p',
    'buruburu_sale_rm_23',
    'buruburu_sale_rm_24',
    'buruburu_sale_rm_25',
    'buruburu_sale_rm_26',
    'buruburu_sale_rm_27',
    'buruburu_sale_rm_28p',
    'buruburu_sale_rm_29',
    'buruburu_sale_rm_30',
    'buruburu_sale_rm_31',
    'buruburu_sale_rm_32',
    'buruburu_sale_rm_33',
    'buruburu_sale_rm_34p',
    'buruburu_sale_rm_35',
    'buruburu_sale_rm_36',
    'buruburu_sale_rm_37',
    'buruburu_sale_rm_38',
    'buruburu_sale_rm_39',
    'buruburu_sale_rm_40p',
    'buruburu_sale_rm_41',
    'buruburu_sale_rm_42',
    'buruburu_sale_rm_43',
    'buruburu_sale_rm_44',
    'buruburu_sale_rm_45',
    'buruburu_sale_rm_46p',
    'buruburu_sale_rm_47',
    'buruburu_sale_rm_48',
    'buruburu_sale_rm_49',
    'buruburu_sale_rm_50',
    'buruburu_sale_rm_51',
  ],
};

/** Similar to default event, but with a special christmas product */
const christmasSale: BundleSaleEvent = {
  items: [
    'buruburu_sale_rm_01_xmas',
    'buruburu_sale_rm_02',
    'buruburu_sale_rm_03',
    'buruburu_sale_rm_04p_2',
    'buruburu_sale_rm_05',
    'buruburu_sale_rm_06',
    'buruburu_sale_rm_07',
    'buruburu_sale_rm_08',
    'buruburu_sale_rm_09',
    'buruburu_sale_rm_10p',
    'buruburu_sale_rm_11',
    'buruburu_sale_rm_12',
    'buruburu_sale_rm_13',
    'buruburu_sale_rm_14',
    'buruburu_sale_rm_15',
    'buruburu_sale_rm_16p',
    'buruburu_sale_rm_17',
    'buruburu_sale_rm_18',
    'buruburu_sale_rm_19',
    'buruburu_sale_rm_20',
    'buruburu_sale_rm_21',
    'buruburu_sale_rm_22p',
    'buruburu_sale_rm_23',
    'buruburu_sale_rm_24',
    'buruburu_sale_rm_25',
    'buruburu_sale_rm_26',
    'buruburu_sale_rm_27',
    'buruburu_sale_rm_28p',
    'buruburu_sale_rm_29',
    'buruburu_sale_rm_30',
    'buruburu_sale_rm_31',
    'buruburu_sale_rm_32',
    'buruburu_sale_rm_33',
    'buruburu_sale_rm_34p',
    'buruburu_sale_rm_35',
    'buruburu_sale_rm_36',
    'buruburu_sale_rm_37',
    'buruburu_sale_rm_38',
    'buruburu_sale_rm_39',
    'buruburu_sale_rm_40p',
    'buruburu_sale_rm_41',
    'buruburu_sale_rm_42',
    'buruburu_sale_rm_43',
    'buruburu_sale_rm_44',
    'buruburu_sale_rm_45',
    'buruburu_sale_rm_46p',
    'buruburu_sale_rm_47',
    'buruburu_sale_rm_48',
    'buruburu_sale_rm_49',
    'buruburu_sale_rm_50',
    'buruburu_sale_rm_51',
  ],
};

/** List of all events  */
export const bundleSaleEvents: BundleSaleEvent[] = [
  boosterSale,
  endlessSale,
  christmasSale,
];

/** List of themes available for bundle sales events */
const themes = ['default', 'xmas', 'newyear'] as const;

/** Bundle sale theme type */
export type BundleSaleTheme = (typeof themes)[number];

/** Definition for special weeks */
export type BundleSaleWeek = {
  theme: BundleSaleTheme;
  event: BundleSaleEvent;
};

/** Default week config */
export const bundleSaleDefaultWeek = {
  theme: 'default' as const,
  event: endlessSale,
};

export const bundleSaleChristmasSaleWeek = {
  theme: 'christmas' as const,
  event: christmasSale,
};

/**
 * Bundle sale schedule, Wednesday 00:00 to Sunday 23:00 every week
 */
export const bundleSaleSchedule = createScheduleComponent<BundleSaleWeek>(
  '2023-12-18',
  'Asia/Tokyo',
  {
    weekly: [
      {
        day: 'Wednesday',
        duration: { days: 4, hours: 23 },
        metadata: bundleSaleDefaultWeek,
      },
    ],
    once: [
      {
        at: '2024-12-25',
        duration: { days: 4, hours: 23 },
        metadata: { ...bundleSaleChristmasSaleWeek, theme: 'xmas' },
      },
      {
        at: '2025-01-01',
        duration: { days: 4, hours: 23 },
        metadata: { ...bundleSaleDefaultWeek, theme: 'newyear' },
      },
    ],
  },
);
